<template>
  <v-container id="top">
    <v-card class="no-print" flat color="transparent">
      <v-row align="start" no-gutters>
        <HelperSearch v-model="search" class="mr-1"></HelperSearch>
        <HelperMenuResult
          v-if="search !== ''"
          :value="search"
          :showOpenHelp="false"
        ></HelperMenuResult>
      </v-row>
    </v-card>
    <v-card flat class="mt-3 markdown">
      <v-card-text class="pb-0">
        <h1>Table des matières</h1>
        <v-list dense>
          <v-list-item
            v-for="(item, index) in tocList"
            :key="index"
            @click="$vuetify.goTo(`#header${index}`)"
          >
            <v-list-item-title>
              <span class="toc-text">{{ item }}</span></v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-text class="pt-0">
        <VueMarkdown ref="markdown" :source="markdown"></VueMarkdown>
      </v-card-text>
    </v-card>
    <v-btn
      class="no-print"
      fixed
      bottom
      right
      fab
      small
      @click="$vuetify.goTo(`#top`)"
    >
      <v-icon>fa-chevron-up</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import VueMarkdown from "vue-markdown";
import { HelperSearch, HelperMenuResult } from "../components";
import { markdownContent } from "../contents";
import { mapGetters } from "vuex";
export default {
  name: "HelperIndex",
  props: {
    value: {
      default: null
    }
  },
  components: {
    VueMarkdown,
    HelperSearch,
    HelperMenuResult
  },
  created() {
    this.markdownValues = markdownContent;
  },
  mounted() {
    this.setData();
  },
  computed: {
    ...mapGetters(["getHelperTopics"]),
    getCurrentHelperTopic() {
      return this.getHelperTopics.find(x => x.value === this.search);
    }
  },
  data() {
    return {
      search: "",
      markdown: "",
      markdownValues: [],
      tocList: []
    };
  },
  methods: {
    setData() {
      if (this.value !== null) {
        this.search = this.value;
      }
    },
    generateToc() {
      if (this.$refs.markdown !== undefined) {
        this.tocList = [];
        const elems = this.$refs.markdown.$el.querySelectorAll("h1, h2");
        elems.forEach((e, i) => {
          e.id = `header${i}`;
          this.tocList.push(e.innerText);
        });
      }
    }
  },
  watch: {
    value() {
      this.setData();
    },
    markdown() {
      setTimeout(() => this.generateToc(), 100);
    },
    getCurrentHelperTopic(v) {
      if (v !== undefined) {
        const markdown = this.markdownValues.find(x => x.text === v.md);
        if (markdown !== undefined) {
          this.markdown = markdown.value;
        } else {
          this.markdown = this.markdownValues.find(
            x => x.text === "NotFound"
          ).value;
        }
      } else {
        this.markdown = "";
      }
    }
  }
};
</script>

<style lang="scss"></style>
